import a from "./index.es84.js";
const {
  Axios: r,
  AxiosError: o,
  CanceledError: e,
  isCancel: t,
  CancelToken: i,
  VERSION: l,
  all: n,
  Cancel: C,
  isAxiosError: d,
  spread: A,
  toFormData: c,
  AxiosHeaders: x,
  HttpStatusCode: m,
  formToJSON: p,
  getAdapter: E,
  mergeConfig: f
} = a;
export {
  r as Axios,
  o as AxiosError,
  x as AxiosHeaders,
  C as Cancel,
  i as CancelToken,
  e as CanceledError,
  m as HttpStatusCode,
  l as VERSION,
  n as all,
  a as default,
  p as formToJSON,
  E as getAdapter,
  d as isAxiosError,
  t as isCancel,
  f as mergeConfig,
  A as spread,
  c as toFormData
};
//# sourceMappingURL=index.es83.js.map
